import React, { useEffect } from "react";
import { UncontrolledInput as Input } from "components/form";
import VMasker from "vanilla-masker";

function Zipcode(props) {
  const prefix = props.prefix || {
    name: "address_attributes[zipcode]",
    id: "address_attributes_zipcode",
  };

  const validation = {
    pattern: /\d{5}\-\d{3}/,
  };

  const messages = {
    pattern: "CEP inválido",
  };

  useEffect(() => {
    VMasker(document.querySelector(".zipcode")).maskPattern("99999-999");
  }, []);

  return (
    <div className="form-group">
      <Input
        {...props}
        className={`${props.className} zipcode`}
        placeholder="_____-___"
        type="text"
        name={prefix.name}
        id={prefix.id}
        label={props.label || "CEP"}
        validation={validation}
        messages={messages}
      />
    </div>
  );
}

export default Zipcode;
